import { ProductService } from "../../services/product.service";
import { Product } from '../../models/product';
import React, { Fragment } from 'react';

import { Link } from 'react-router-dom';
import KeyValueDisplayer from '../../components/key-value-displayer/Key-Value-Displayer';
import UserNavBar from '../../components/user-nav-bar/UserNavBar';
import UserTweetCard from '../../components/user-tweet-card/UserTweetCard';

import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import './Product-Detail.scss';
import { LikeService } from '../../services/like.service';
import { AppContext } from '../../lib/app-context';
import CreateUserTweet from '../../components/create-user-tweet/CreateUserTweet';
import { UserTweet } from '../../models/user-tweet';
import { Editor, EditorState } from 'draft-js';
import { RichEditorDisplay } from '../../components/rich-editor-display/RichEditorDisplay';
import { createReadOnlyEditor, formatMoney, getProductDetailFullUrl, getProductDetailUrl, getProductUrl, getUserStoreFullUrl, getUserStoreUrl, toSeoUrl } from '../../lib/common-helper';
import { stateFromHTML } from 'draft-js-import-html';
import { ProductCategory } from "../../models/product-category";
import { ProductStatusEnum } from "../../lib/enums";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';

import {
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
} from "react-share";
import { ProductVariation } from "../../models/product-variation";

import { Swiper, SwiperSlide } from "swiper/react";


// import required modules
import { FreeMode, Navigation, Thumbs } from "swiper";
import LazyLoad from 'react-lazyload';
import { LeftArrow, RightArrow } from "../../components/horizontal-scroll/arrows";
import { ScrollProduct } from "../../components/horizontal-scroll/scroll-product";
import { ScrollMenu } from 'react-horizontal-scrolling-menu';


interface IProps {
}

interface IState {
  product: Product;
  currentProductVariation: ProductVariation;
  defaultProductImage: string;
  thumbsSwiper: any;
  thumbsSwiperVariation: any;
  storeOtherProducts: Product[];
}


export default class ProductDetail extends React.Component<any, IState>  {

  static contextType = AppContext;

  likeService: LikeService = new LikeService();

  productId: number;

  state: IState = {
    product: null,
    currentProductVariation: null,
    defaultProductImage: process.env.REACT_APP_DEFAULT_PRODUCT_IMAGE,
    thumbsSwiper: null,
    thumbsSwiperVariation: null,
    storeOtherProducts: []
  };

  productService: ProductService = new ProductService();

  constructor(props) {
    super(props);
    this.productId = props.match.params.productId;
  }

  async componentDidMount() {
    this.setInit(this.productId);


    // Swiper Nav color
    document.documentElement.style.setProperty('--swiper-navigation-color', '#fff');
    document.documentElement.style.setProperty('--swiper-pagination-color', '#fff');
  }


  async componentWillReceiveProps(nextProps) {
    if (this.props.match.params.productId != nextProps.match.params.productId) {
      this.setInit(nextProps.match.params.productId);
    }
  }

  async componentDidUpdate() {
  }


  async setInit(productId: number) {

    if (productId) {

      let product = await this.productService.getProduct(productId);
      let storeOtherProducts = await this.productService.getStoreOtherProducts(productId);


      document.title = 'Showqace | ' + product.publicUserResponse.name + ' | ' + product.name;

      this.setState(
        {
          product: product,
          storeOtherProducts: storeOtherProducts
        }
      );
    }

  }


  unshiftUserTweet(userTweet: UserTweet) {
    this.setState({
      product:
      {
        ...this.state.product,
        userTweets: [userTweet, ...this.state.product.userTweets]
      }
    })

  }


  addProductLike(productId: number) {
    this.likeService.addProductLike(productId).then(productLike => {

      this.setState(
        {
          product: {
            ...this.state.product,
            likes: [...this.state.product.likes, productLike]
          }
        });

    });
  }

  deleteProductLike(likeId: number) {

    this.likeService.deleteLike(likeId).then(y => {

      this.setState(
        {
          product: {
            ...this.state.product,
            likes: this.state.product.likes.filter(x => x.id != likeId)
          }
        });

    });
  }



  createEditor(value: string): any {
    if (value) {
      let valueParsed = JSON.parse(value);
      let valueEditorContent = stateFromHTML(valueParsed);
      return EditorState.createWithContent(valueEditorContent);
    }
    else {
      return EditorState.createEmpty();
    }
  }


  getWhatsAppUrl(): string {

    let price: string = "";

    if (this.state.currentProductVariation?.primaryPrice) {
      price = formatMoney(this.state.currentProductVariation?.primaryPrice, this.state.product.primaryCurrency?.code);
    }
    else if (this.state.product?.primaryPrice) {
      price = formatMoney(this.state.product?.primaryPrice, this.state.product.primaryCurrency?.code);
    }

    let productTextEncoded: string = encodeURI('Hello ' + this.state.product.publicUserResponse.username + ', I saw your product on showqace.com, am interested in the below item \n\r\n\r' +
      getProductDetailFullUrl(this.state.product.publicUserResponse.username, this.state.product) + "\n\r" +
      (this.state.product?.name ? "Product Name: " + this.state.product?.name : "") + "\n\r" +
      (price ? "Product Price: " + price : "") + "\n\r" +
      (this.state.currentProductVariation?.name ? "Product Option: " + this.state.currentProductVariation?.name : "")
    );

    return "https://wa.me/" + this.state.product.publicUserResponse.whatsapp + "?text=" + productTextEncoded
  }

  drawProductDetailHeader(): any {

    let productCategories_Products = JSON.parse(JSON.stringify(this.state.product.productCategories_Products));

    let productCategoryRoot = productCategories_Products.find(x => x.productCategory?.parentId == null)?.productCategory;


    let productCategoryies = JSON.parse(JSON.stringify(this.state.product.productCategories_Products))
      .map(x => {

        x.productCategory.children = [];
        return x.productCategory;
      });




    if (productCategoryRoot) {


      const nest = (items, id = null, link = 'parent_id') =>
        productCategoryies
          .filter(item => item.parentId === id)
          .map(item => ({ ...item, children: nest(items, item.id) }));

      if (productCategoryRoot.children?.length > 0) {
        let result = nest(JSON.parse(JSON.stringify(productCategoryies)));

        if (result?.length == 1) {
          productCategoryRoot = result[0];
        }
      }
    }


    // Render Breadcrumb and Tags
    return (
      <div className="d-flex align-items-center pb-2 flex-wrap" style={{ borderBottom: "solid #eee 1px" }}>

        <div className="d-flex align-items-center me-4">
          <Link style={{ textDecoration: "none" }} className="breadcrumb-item" to={getUserStoreUrl(this.state.product.publicUserResponse.username)}>
            <img style={{ width: 75, height: 75 }} className="img-thumbnail img-circle rounded-circle" src={this.state.product.publicUserResponse.avatarFullURL} />
          </Link>

          <nav aria-label="breadcrumb">
            <ol className="product-breadcrumb breadcrumb mb-0  align-items-center">
              {/* {
                <li className="breadcrumb-item">
  
                </li>
              } */}

              {
                productCategoryRoot &&
                <li className="breadcrumb-item">
                  <span className="ms-2 me-2">/</span>
                  <Link style={{ textDecoration: "none" }} className="breadcrumb-item width100p" to={getUserStoreUrl(this.state.product.publicUserResponse.username, productCategoryRoot.id)}>
                    {
                      productCategoryRoot.name
                    }
                  </Link>
                </li>
              }

              {
                productCategoryRoot?.children?.length > 0 &&
                this.drawBreadCrumbChild(productCategoryRoot.children[0])
              }

            </ol>
          </nav>
        </div>

        {/* <div className="mt-2 mt-md-0 flex-grow-1 d-block d-lg-none">

          <Link className="btn btn-third width100p" to={getUserStoreUrl(this.state.product.publicUserResponse.username)}>
            Go to store
          </Link>

        </div> */}

        <div className="mt-2 mt-md-0 ms-auto">

          <Link className="btn btn-third width100p" to={getUserStoreUrl(this.state.product.publicUserResponse.username)}>
            Go to store
          </Link>

        </div>



      </div>
    )



  }


  drawBreadCrumbChild(childProductCategory: ProductCategory) {
    return (
      (
        childProductCategory &&
        <>
          <li className="breadcrumb-item" >
            <Link style={{ textDecoration: "none" }} className="breadcrumb-item" to={getUserStoreUrl(this.state.product.publicUserResponse.username, childProductCategory.id)}>
              {
                childProductCategory.name
              }
            </Link>
          </li>
          {
            childProductCategory.children?.length > 0 &&
            this.drawBreadCrumbChild(childProductCategory.children[0])
          }
        </>
      )
    );
  }


  setCurrentProductVariation(productVariation: ProductVariation) {
    if (this.state.currentProductVariation?.id == productVariation.id) {
      this.setState({ currentProductVariation: null })
      // this.setState({currentProductImages: productVariationItem.im })
    }
    else {
      this.setState({ currentProductVariation: productVariation });
    }
  }


  productCardClicked(product: Product) {

    let redirectionUrl = getProductDetailFullUrl(product.publicUserResponse.username, product);

    if (redirectionUrl) {
      window.location.href = redirectionUrl;
    }

  }

  goToStore() {

    let redirectionUrl = getUserStoreFullUrl(this.state.product.publicUserResponse.username);

    if (redirectionUrl) {
      window.location.href = redirectionUrl;
    }

  }






  render() {

    return (
      <div className="page-wrapper container mt-2">

        {/* {
          this.state.product?.publicUserResponse?.username &&
          <UserNavBar publicUser={this.state.product.publicUserResponse} />
        } */}

        <div className="container">

          {this.state?.product &&
            <div className="mt-2">

              {
                this.drawProductDetailHeader()
              }


              <div className="row mt-3" >

                {

                  <div className="col-md-6 col-lg-5"

                    style={{
                      display:
                        (
                          (!this.state.currentProductVariation?.productVariationImages || this.state.currentProductVariation.productVariationImages.length <= 0)
                          && (this.state.product?.productImages?.length > 0)
                        ) ? "block" : "none"
                    }}
                  >

                    <Swiper
                      spaceBetween={10}
                      navigation={true}
                      thumbs={{ swiper: this.state.thumbsSwiper }}
                      modules={[FreeMode, Navigation, Thumbs]}
                      className="mySwiper2"
                    // style={{
                    //   "--swiper-navigation-color": "#fff",
                    //   "--swiper-pagination-color": "#fff",
                    // }}
                    >
                      {
                        this.state.product.productImages.map(productImage =>
                          <SwiperSlide key={productImage.id}>
                            <img src={productImage.imageFullURL} style={{ objectFit: "cover", maxHeight: 600, width: "100%" }} />
                          </SwiperSlide>
                        )
                      }
                    </Swiper>

                    <Swiper
                      onSwiper={(e) => this.setState({ thumbsSwiper: e })}
                      spaceBetween={10}
                      slidesPerView={4}
                      freeMode={true}
                      watchSlidesProgress={true}
                      modules={[FreeMode, Navigation, Thumbs]}
                      className="mySwiper mt-2 mb-2"
                    >
                      {
                        this.state.product.productImages.map(productImage =>
                          <SwiperSlide key={productImage.id}>
                            <img src={productImage.imageFullURL} style={{ objectFit: "cover", maxHeight: 600, width: "100%", height: "75px" }} />
                          </SwiperSlide>
                        )
                      }
                    </Swiper>


                    {/* <Carousel swipeable={true} showIndicators={false} showStatus={false} showArrows={true} >
                      {
                        this.state.product.productImages.map(productImage =>
                          <div key={productImage.id} >
                            <img src={productImage.imageFullURL} style={{ objectFit: "cover", maxHeight: 600, width: "100%" }} />
                          </div>
                        )
                      }
                    </Carousel> */}
                  </div>
                }

                {/************** PRODUCT VARIATION IMAGE SWIPER  ******************/}
                {
                  <div

                    className={

                      (this.state.currentProductVariation?.productVariationImages && this.state.currentProductVariation.productVariationImages.length > 0)
                        ? "col-md-6 col-lg-5" : "hidden"
                    }
                  >

                    <Swiper
                      spaceBetween={10}
                      navigation={true}
                      thumbs={{ swiper: this.state.thumbsSwiperVariation }}
                      modules={[FreeMode, Navigation, Thumbs]}
                      className="mySwiper2"
                    // style={{
                    //   "--swiper-navigation-color": "#fff",
                    //   "--swiper-pagination-color": "#fff",
                    // }}
                    >
                      {
                        this.state.currentProductVariation?.productVariationImages?.map(productVariationImage =>
                          <SwiperSlide key={productVariationImage.id}>
                            <img src={productVariationImage.imageFullURL} style={{ objectFit: "cover", maxHeight: 600, width: "100%" }} />
                          </SwiperSlide>
                        )
                      }
                    </Swiper>

                    <Swiper
                      onSwiper={(e) => this.setState({ thumbsSwiperVariation: e })}
                      spaceBetween={10}
                      slidesPerView={4}
                      freeMode={true}
                      watchSlidesProgress={true}
                      modules={[FreeMode, Navigation, Thumbs]}
                      className="mySwiper mt-2 mb-2"
                    >
                      {
                        this.state.currentProductVariation?.productVariationImages?.map(productVariationImage =>
                          <SwiperSlide key={productVariationImage.id}>
                            <img src={productVariationImage.imageFullURL} style={{ objectFit: "cover", maxHeight: 600, width: "100%", height: "75px" }} />
                          </SwiperSlide>
                        )
                      }
                    </Swiper>


                  </div>


                  // this.state.currentProductVariation?.productVariationImages && this.state.currentProductVariation.productVariationImages.length > 0 &&
                  // <div className="col-md-6 col-lg-5" >
                  //   <Carousel swipeable={false} showIndicators={false} showStatus={false} showArrows={true} >
                  //     {
                  //       this.state.currentProductVariation.productVariationImages.map(productVariationImage =>
                  //         <div key={productVariationImage.id} >
                  //           <img src={productVariationImage.imageFullURL} style={{ objectFit: "cover", maxHeight: 600, width: "100%" }} />
                  //         </div>
                  //       )
                  //     }
                  //   </Carousel>
                  // </div>
                }

                <div className={this.state.product?.productImages?.length > 0 ? "col-md-6 col-lg-7" : "col-md-12"}>
                  <div className="d-flex align-items-end">
                    <h1 className="pb-0 mb-0">
                      {this.state.product.name}
                    </h1>

                    <div className="ms-auto">
                      <div className="d-flex">
                        {
                          this.state.product.publicUserResponse.username == this.context.currentUser?.username &&
                          <Link className="btn btn-primary ms-4" to={"/product/save/" + this.state.product.id}>
                            <i className="bi bi-pencil"></i>
                          </Link>
                        }
                      </div>
                    </div>

                  </div>
                  <div className="">
                    <Link to={getUserStoreUrl(this.state.product.publicUserResponse?.username)} className="text-body" >
                      {"by " + this.state?.product?.publicUserResponse?.name}
                    </Link>
                  </div>

                  <div className="mt-2">
                    {
                      (this.state.product.primaryPrice || this.state.currentProductVariation?.primaryPrice) &&
                      this.state.product.productStatusId == ProductStatusEnum.Enabled &&
                      <div>
                        <span className="fs-5">
                          Price:
                        </span>
                        <span className="fs-5">
                          {
                            this.state.currentProductVariation?.primaryPrice ?
                              " " + formatMoney(this.state.currentProductVariation.primaryPrice, this.state.product.primaryCurrency?.code)
                              :
                              " " + formatMoney(this.state.product.primaryPrice, this.state.product.primaryCurrency?.code)
                          }

                        </span>
                      </div>
                    }
                    {
                      this.state.product.productStatusId == ProductStatusEnum.OutOfStock &&
                      <div className="mt-3">
                        <span className="p-1 nowrap red" style={{ border: "solid #e6061b 1px" }} >
                          OUT OF STOCK
                        </span>
                      </div>
                    }
                  </div>







                  {
                    // user is not logged in or user is owner => dont show button
                    (!this.context.currentUser?.username || this.state.product.publicUserResponse.username == this.context.currentUser?.username) &&
                    <div className="fs-6 text-body nowrap mt-3">
                      <i className="bi bi-heart me-2"></i>
                      <span>
                        {this.state.product.likes?.length}
                      </span>
                    </div>
                  }

                  {
                    // user is logged in and not owner
                    this.context.currentUser?.username && this.state.product.publicUserResponse.username != this.context.currentUser?.username &&
                    <div className="mt-3">
                      {
                        this.state.product.likes?.length > 0 &&
                        this.state.product.likes.find(x => x.publicUserResponse?.username == this.context.currentUser?.username) &&
                        <button type="button" className="btn pt-0 ps-0 pb-0" style={{ color: "#E0245E" }}
                          onClick={() => this.deleteProductLike(this.state.product.likes.find(x => x.publicUserResponse?.username == this.context.currentUser?.username).id)}>
                          <i className="bi bi-heart-fill me-2"></i>
                          <span>
                            {this.state.product.likes?.length}
                          </span>
                        </button>
                      }
                      {
                        (
                          !(this.state.product.likes?.length > 0) ||
                          !(this.state.product.likes.find(x => x.publicUserResponse?.username == this.context.currentUser?.username))) &&
                        <button className="btn pt-0 ps-0  pb-0" type="button" onClick={() => this.addProductLike(this.state.product.id)}>
                          <i className="bi bi-heart me-2"></i>
                          <span>
                            {this.state.product.likes?.length}
                          </span>
                        </button>
                      }
                    </div>

                  }

                  {/* Whatsapp Button  */}
                  {
                    this.state.product.publicUserResponse.whatsapp &&
                    <div className="mt-3">
                      <a target="_blank" style={{ textDecoration: "none", display: "inline-block" }}
                        className="product-detail-order-button"
                        href={this.getWhatsAppUrl()}>

                        <button className="btn btn-primary btn-whatsapp-order-wrapper d-flex align-items-center" >

                          <i className="bi bi-whatsapp fs-5"></i>


                          {
                            this.state.product.productStatusId == ProductStatusEnum.OutOfStock &&
                            <span className="ms-2 ps-2">
                              CONTACT
                            </span>
                          }

                          {
                            this.state.product.productStatusId != ProductStatusEnum.OutOfStock &&
                            <span className="ms-2 ps-2">
                              ORDER
                            </span>
                          }




                        </button>
                      </a>
                    </div>
                  }


                  {
                    this.state.product.productVariations && this.state.product.productVariations.length > 0 &&
                    <div>

                      <hr />
                      <div className="fs-6 text-center light-bold">
                        Product Options
                      </div>

                      <div className="mt-4">
                        {/* <b>Decription</b> <br /> */}
                        {/* <span className="fs-5">
                        {this.state.product.shortDescription}
                      </span> */}


                        <div className="d-flex flex-wrap">
                          {
                            this.state.product.productVariations && this.state.product.productVariations.map(productVariation =>

                              <div key={productVariation.id}
                                className={"product-variation-item me-3 mb-3 d-flex flex-column" +
                                  (this.state.currentProductVariation?.id == productVariation.id ? " product-variation-item-active " : '')}

                                onClick={() => {
                                  this.state.currentProductVariation?.id == productVariation.id ?
                                    this.setState({ currentProductVariation: null })
                                    :
                                    this.setState({ currentProductVariation: productVariation })
                                }}>
                                {
                                  productVariation.productVariationImages && productVariation.productVariationImages.length > 0 && productVariation.productVariationImages[0]?.imageFullURL &&
                                  <div className="mx-auto" style={{ width: "75px", height: "75px" }}>
                                    {
                                      productVariation.productVariationImages && productVariation.productVariationImages.length > 0 && productVariation.productVariationImages[0]?.imageFullURL &&
                                      <img title={productVariation.name} className="p-2" src={productVariation.productVariationImages[0].imageFullURL}
                                        style={{ objectFit: "contain", width: "100%", height: "100%" }} />
                                    }
                                  </div>
                                }
                                <div className="fs-7 p-1 text-center"
                                  style={{
                                    width: "75px",
                                    borderLeft: "none",
                                    borderRight: "none",
                                    borderBottom: "none",
                                    borderTop: "none",
                                    margin: "auto"
                                  }}>

                                  <div>
                                    {
                                      productVariation.name
                                    }
                                  </div>
                                  {
                                    productVariation.primaryPrice &&
                                    <div className="mt-1 light-bold">
                                      {
                                        formatMoney(productVariation.primaryPrice, this.state.product.primaryCurrency?.code)
                                      }
                                    </div>
                                  }
                                </div>
                              </div>
                            )
                          }
                        </div>

                      </div>

                    </div>
                  }


                  {
                    this.state.product.shortDescription &&
                    <div>

                      <hr />


                      <div className="mt-4">
                        {/* <b>Decription</b> <br /> */}
                        {/* <span className="fs-5">
                        {this.state.product.shortDescription}
                      </span> */}



                        <RichEditorDisplay
                          editorState={createReadOnlyEditor(this.state.product.shortDescription)}
                        />


                      </div>

                    </div>
                  }

                </div>

              </div>




              <div className="">

                <div className="">

                  {
                    this.state.product.specifications?.length > 0 &&
                    <div>
                      <hr className="mt-4 mb-4" />

                      <div className="pb-1 mt-1">
                        <h4>Specification</h4>
                        <KeyValueDisplayer keyValues={this.state.product.specifications} />

                      </div>
                    </div>
                  }





                </div>


                {
                  this.state.product.description &&
                  <div>
                    <hr className="mt-4 mb-4" />

                    {/* <h4>Description</h4> */}
                    <RichEditorDisplay
                      editorState={createReadOnlyEditor(this.state.product.description)}
                    />
                  </div>
                }

                <div className="" >
                  {
                    <div style={{ backgroundColor: "#fff", }}>
                      {
                        <div className="row mt-4 pt-3 pb-3" style={{ backgroundColor: "#fff" }} >
                          <div className="col-12">
                            <Link to={getUserStoreUrl(this.state.product.publicUserResponse?.username)} className="text-body no-underline" >
                              <h4>Other Products</h4>
                            </Link>
                          </div>
                          <LazyLoad offset={150} once height={200}>
                            <div className="">
                              <ScrollMenu

                                LeftArrow={LeftArrow}
                                RightArrow={RightArrow}
                              // onWheel={this.onWheel}
                              >
                                {
                                  this.state.storeOtherProducts?.map((storeOtherProduct) =>
                                  (
                                    <ScrollProduct
                                      product={storeOtherProduct}
                                      itemId={storeOtherProduct.id.toString()} // NOTE: itemId is required for track items
                                      key={storeOtherProduct.id}
                                      fireClickAction={() => this.productCardClicked(storeOtherProduct)}
                                    />

                                    // <ScrollItem
                                    //   fireClickAction={() => this.initAndOnPropChange(this.state.userProductResponse, productCategory.id)}
                                    //   // publicUserResponse={this.state.userProductResponse.publicUserResponse}
                                    //   category={productCategory}
                                    //   itemId={productCategory.id.toString()}
                                    //   key={productCategory.id}
                                    // />

                                  )
                                  )
                                }
                              </ScrollMenu>
                            </div>
                          </LazyLoad>


                          <button type="button" onClick={() => this.goToStore()}
                            className="btn btn-third d-block d-md-none mt-2">
                            View Store
                          </button>

                          <div className="d-none d-md-block text-end mt-2">
                            <button type="button" onClick={() => this.goToStore()}
                              className="btn btn-third px-5">
                              View Store
                            </button>
                          </div>


                        </div>
                      }

                    </div>
                  }
                </div>



                <div className="mt-2">

                  {/* {
                    (this.context.currentUser?.username || this.state.product.userTweets?.length > 0) &&
                    <div>
                      <hr className="mt-4 mb-4" />
                      <h4>Share</h4>
                      <div className="mb-4">

                        <FacebookShareButton
                          // url={window.location.href}
                          url={"https://showqace.com"}
                          quote="this is amazing!"
                          className=""
                        >
                          <FacebookIcon size={32} round />
                        </FacebookShareButton>

                      </div>
                    </div>
                  } */}


                  {
                    (this.context.currentUser?.username || this.state.product.userTweets?.length > 0) &&
                    <div>
                      <hr className="mt-4 mb-4" />
                      <h4>Comments</h4>
                    </div>
                  }


                  {
                    this.context.currentUser?.username &&
                    <div className="mb-4">
                      <CreateUserTweet postSave={(x) => this.unshiftUserTweet(x)} placeholder="Feedback or suggestion?" productId={this.state.product.id} />
                    </div>
                  }

                  <div className="">
                    {
                      this.state.product.userTweets.map(userTweet =>
                        <UserTweetCard key={userTweet.id} userTweet={userTweet} />
                      )
                    }
                  </div>
                </div>

              </div>




            </div>

          }

        </div>
      </div>
    );
  }
}
